import React from 'react'
import StudentList from '../../components/collage/StudentList'

export default function Students() {
  return (
    <div>Students
        <StudentList/>
    </div>
  )
}
